import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Modal, Form, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getStandardEvents, createStandardEvent, updateStandardEvent, deleteStandardEvent } from '../services/api';
import { toast } from 'react-toastify';

const StandardEventsPage = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentEvent, setCurrentEvent] = useState(null);
    const [eventTitle, setEventTitle] = useState('');

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const response = await getStandardEvents();
            setEvents(response.data);
            setError(null);
        } catch (error) {
            console.error("Errore nel recupero dei titoli standard:", error);
            setError("Impossibile caricare i titoli standard.");
            toast.error("Impossibile caricare i titoli standard.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentEvent(null);
        setEventTitle('');
    };

    const handleShowModal = (event = null) => {
        setCurrentEvent(event);
        setEventTitle(event ? event.title : '');
        setShowModal(true);
    };

    const handleSave = async () => {
        if (!eventTitle.trim()) {
            toast.warn("Il titolo non può essere vuoto.");
            return;
        }

        try {
            if (currentEvent) {
                await updateStandardEvent(currentEvent.id, { title: eventTitle });
                toast.success("Titolo aggiornato con successo!");
            } else {
                await createStandardEvent({ title: eventTitle });
                toast.success("Nuovo titolo creato con successo!");
            }
            fetchEvents();
            handleCloseModal();
        } catch (error) {
            console.error("Errore nel salvataggio del titolo:", error);
            toast.error("Errore nel salvataggio del titolo.");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Sei sicuro di voler eliminare questo titolo?")) {
            try {
                await deleteStandardEvent(id);
                toast.success("Titolo eliminato con successo!");
                fetchEvents();
            } catch (error) {
                console.error("Errore nell'eliminazione del titolo:", error);
                toast.error("Errore nell'eliminazione del titolo.");
            }
        }
    };

    return (
        <Container className="mt-4">
            <h1>Gestione Titoli Evento Standard</h1>
            <p>Qui puoi gestire i titoli predefiniti che appaiono come suggerimenti nel campo "Titolo" quando crei un nuovo evento nel calendario.</p>
            
            <Button variant="primary" onClick={() => handleShowModal()} className="mb-3">
                <FontAwesomeIcon icon={faPlus} /> Aggiungi Nuovo Titolo
            </Button>

            {loading && <p>Caricamento in corso...</p>}
            {error && <Alert variant="danger">{error}</Alert>}
            
            {!loading && !error && (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Titolo</th>
                            <th style={{ width: '120px' }}>Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.map((event) => (
                            <tr key={event.id}>
                                <td>{event.title}</td>
                                <td>
                                    <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleShowModal(event)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </Button>
                                    <Button variant="outline-danger" size="sm" onClick={() => handleDelete(event.id)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{currentEvent ? 'Modifica Titolo' : 'Nuovo Titolo'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="eventTitle">
                            <Form.Label>Titolo Evento</Form.Label>
                            <Form.Control
                                type="text"
                                value={eventTitle}
                                onChange={(e) => setEventTitle(e.target.value)}
                                placeholder="Es. Ritiro pacco Mirakl"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Annulla
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Salva
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default StandardEventsPage;
